import { action, computed, observable, runInAction } from 'mobx';

import identityClient from '../clients/identityClient';
import { setAAID } from '../sentry';
import { captureException } from '../sentry/index';
import { ErrorSource } from '../sentry/types';

import { ApiStore } from './base/apiStore';

export default class UserStore extends ApiStore {
  @observable accountId?: string;
  @observable email?: string;
  @observable locale?: string;
  @observable name?: string;
  @observable picture?: string;

  readyPromise: Promise<string>;
  rejectReady!: () => void;
  resolveReady!: (accountId: string) => void;

  constructor() {
    super();
    this.readyPromise = new Promise((resolve, reject) => {
      this.resolveReady = resolve;
      this.rejectReady = reject;
    });
  }

  @action
  async getUser() {
    try {
      this.setLoadingApiState();
      // The retry is here just in case /me endpoint isn't ready right after sign up
      const response = await identityClient.getUser({ retryMS: [250] });
      setAAID(response.account_id);
      this.resolveReady(response.account_id);
      runInAction(() => {
        this.name = response.name;
        this.accountId = response.account_id;
        this.email = response.email;
        this.locale = response.locale;
        this.picture = response.picture;
      });
      this.setSuccessApiState();
    } catch (e) {
      // Don't want this error to propagate up
      this.rejectReady();
      captureException(e, { source: ErrorSource.USER_STORE });
      this.setErrorApiState(e);
    }
  }

  @computed
  get isLocaleEnglish() {
    return (this.locale || '').startsWith('en');
  }
}
